import { getConfig } from '../Config/ApplicationConfig';
import { getExecutor, HttpQuery } from '../Shared/HttpRequestExecutor';
import { LookupIdentifier } from '../Shared/SharedModels';
import { Nullable } from '../Shared/Types';
import { DeviceStatus } from './ServicesAustraliaModels';

export const searchDevices: HttpQuery<SearchDeviceContracts.Response.DevicesSearchResult[]> = (
    config,
    searchPayload: SearchDeviceContracts.Request.SearchDevices,
    limit = 6
) =>
    getExecutor(getConfig().apiEndpoints.servicesAustralia).postCancellable(
        `api/v1/devices/search?limit=${limit}`,
        config,
        searchPayload
    );

export namespace SearchDeviceContracts {
    export namespace Request {
        export interface SearchDevices {
            devices: {
                authoringSystem: string;
                authoringSystemForeignKey: string;
            }[];
            deviceExpiresWithin: Nullable<string>;
            keyExpiresWithin: Nullable<string>;
            statuses: DeviceStatus[];
        }
    }

    export namespace Response {
        export interface DevicesSearchResult {
            id: string;
            authoringSystem: string;
            authoringSystemForeignKey: string;
            customer: DeviceDetailsResponseCustomer;
            applicationClientIdentifier: string;
            prodaDeviceName: string;
            prodaOrganisationIdentifier: string;
            instanceQueueName: string;
            prodaClientIdentifier: string;
            applicationName: string;
            status: DeviceStatus;
            expiresOn: string;
            errors: DeviceDetailsError[];
        }

        interface DeviceDetailsResponseCustomer extends LookupIdentifier {
            enabled: boolean;
        }

        interface DeviceDetailsError {
            code: string;
            message: string;
        }
    }
}
